module.exports = __webpack_public_path__ + "static/media/order_waiting.bb641b35.png";